export const nameReducer = 'zone';
